import type { GeoPoint } from "@punchup/data/models";
import { ShowWithComedian } from "@/data/shows";
import { genAbsoluteURL } from "@/components/common/utils";

export interface TicketmasterShowsParams {
  city: string;
  stateCode?: string;
  countryCode: string;
  point?: GeoPoint;
  radius?: number;
  startDateTime?: string;
  endDateTime?: string;
  maxShowsPerWeek?: number;
}

export interface TicketmasterShowsResponse {
  data: ShowWithComedian[];
  metadata: {
    totalFound: number;
    totalReturned: number;
    source: string;
  };
}

/**
 * Fetch comedy shows from Ticketmaster Discovery API
 */
export async function fetchTicketmasterComedyShows(
  params: TicketmasterShowsParams
): Promise<ShowWithComedian[]> {
  try {
    const searchParams = new URLSearchParams({
      city: params.city,
      countryCode: params.countryCode,
      radius: (params.radius || 25).toString(),
      ...(params.stateCode && { stateCode: params.stateCode }),
      ...(params.point && {
        latitude: params.point.latitude.toString(),
        longitude: params.point.longitude.toString(),
      }),
      ...(params.startDateTime && { startDateTime: params.startDateTime }),
      ...(params.endDateTime && { endDateTime: params.endDateTime }),
      ...(params.maxShowsPerWeek && {
        maxShowsPerWeek: params.maxShowsPerWeek.toString(),
      }),
    });

    const url = genAbsoluteURL(
      `/api/v2/public/ticketmaster-comedy-shows?${searchParams.toString()}`
    );

    const response = await fetch(url);

    if (!response.ok) {
      console.error(
        "Ticketmaster API fetch failed:",
        response.status,
        response.statusText
      );
      return [];
    }

    const result: TicketmasterShowsResponse = await response.json();

    return result.data || [];
  } catch (error) {
    console.error("Error fetching Ticketmaster shows:", error);
    return [];
  }
}
